import React from "react";
import EntityList from "../../EntityList/EntityList";

class CancellationPolicyConfigurationList extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.handleDelete = this.handleDelete.bind(this);
    this.handleToggle = this.handleToggle.bind(this);
    this.handleSort = this.handleSort.bind(this);
  }

  componentDidMount() {}

  componentWillUnmount() {}

  handleToggle({ event, field, entity, idx }) {
    event.preventDefault();
    event.stopPropagation();
    this.props.onToggleListItem({
      id: entity.id,
      entity,
      idx,
      field,
    });
  }

  handleDelete({ event, entity, idx }) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    return this.props.onDeleteListItem({
      id: entity.id,
      entity,
      idx,
    });
  }

  handleSort({ event, field, entity, newIndex, oldIndex, swappedEntity }) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    return this.props.onSortListItem({
      id: entity.id,
      entity,
      field,
      newIndex,
      swappedEntity,
      oldIndex,
    });
  }

  render() {
    const { config } = this.props;
    const { name, entityName, validation, fields, renderers, sorting } = config;
    const {
      entities,
      loading,
      entityError,
      entityResult,
      handleCreate,
      handleEdit,
      nested,
      disabled,
    } = this.props;
    const { handleToggle, handleDelete, handleSort } = this;
    return (
      <EntityList
        loading={loading}
        entityName={entityName}
        entities={entities}
        validation={validation}
        renderers={renderers}
        name={name}
        fields={fields}
        onToggle={handleToggle}
        onDelete={handleDelete}
        onSort={handleSort}
        entityError={entityError}
        entityResult={entityResult}
        handleCreate={handleCreate}
        handleEdit={handleEdit}
        nested={nested}
        sorting={sorting}
        disabled={disabled}
      />
    );
  }
}

CancellationPolicyConfigurationList.propTypes = {};

CancellationPolicyConfigurationList.defaultProps = {};

export default CancellationPolicyConfigurationList;
